import { useTheme } from "@/src/styles/theme-provider";
import { Modal, ModalProps, View } from "react-native";

type ThemedModalProps = ModalProps & {
  children: React.ReactNode;
};

export default function ThemedModal({
  children,
  ...modalProps
}: ThemedModalProps) {
  // varStyle is the real nativewind vars() object — registers the theme
  // variables for this Modal subtree (Modals render outside the provider tree).
  const { varStyle } = useTheme();

  return (
    <Modal {...modalProps}>
      <View style={[varStyle, { flex: 1 }]}>{children}</View>
    </Modal>
  );
}
